var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "51px",
    viewBox: "0 0 50 51",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "03-Token-Generator-(Billing-Grond-Floor)",
    transform: "translate(-323.000000, -378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(22.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(20.000000, 179.378875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(281.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#6C3964",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-search-1279709",
    transform: "translate(10.000000, 10.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7449023,28.512193 L21.6246692,20.3920221 C23.5039374,18.228201 24.6454557,15.4075133 24.6454557,12.322945 C24.6454557,5.52871979 19.1176283,0 12.3224163,0 C5.52751594,0 1.77635684e-15,5.52853286 1.77635684e-15,12.322945 C1.77635684e-15,19.1171703 5.52732901,24.645267 12.3224163,24.645267 C15.4062605,24.645267 18.2270321,23.5040066 20.3903091,21.6245036 L28.5111652,29.7446745 C28.6815456,29.9150535 28.9047398,30 29.1281771,30 C29.3511283,30 29.5745718,29.9148105 29.7444599,29.7446745 C30.0852206,29.4041656 30.0852206,28.8516551 29.7442165,28.5111338 L29.7449023,28.512193 Z M1.74530179,12.3235681 C1.74530179,6.4908404 6.49057857,1.74528842 12.3230394,1.74528842 C18.1558118,1.74528842 22.9014002,6.49077809 22.9014002,12.3235681 C22.9014002,18.1563582 18.1561234,22.9012247 12.3230394,22.9012247 C6.49051626,22.9012247 1.74530179,18.1562335 1.74530179,12.3235681 Z",
    id: "Shape"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/searchicon.2c739c1c68a62859eb1ace8974a8d2b1.svg";
export { ForwardRef as ReactComponent };